import React from 'react';
import { getMetricShortName } from '@src/utils/metrics';

const MetricColumnRenderer = ({ cellData }) => {
  const shortName = getMetricShortName({ metricKey: cellData, hasSubscript: false });
  return <>{shortName}</>;
};

export default MetricColumnRenderer;
